export default [
  {
    name: 'error404',
    path: '*',
    component() {
      return import('@/pages/error/404.vue')
    },
  },
  {
    name: 'error500',
    path: '/500',
    component() {
      return import('@/pages/error/500.vue')
    },
  },
]
